export const projectImages = {
  sales_board_icon: 'assets/img/menuIcon/sales_board.svg',
  lock_close_icon: 'assets/img/graphics/lock-close.svg',
  lock_open_icon: 'assets/img/graphics/lock-open.svg',
  browse_icon: 'assets/img/svg/brows-button.svg',
  long_arrow_down_icon: 'assets/img/arrow/long-arrow-down.png',
  long_arrow_right_icon: 'assets/img/arrow/long-arrow-right.png',
  grab_me_icon: 'assets/img/flowy-workflow/grabme.svg',
  up_down_arrow_icon: 'assets/img/menuIcon/up_down_arrow.svg',
  unit_lot_icon: 'assets/img/bed-bath/unit-lot.svg',
  floorplan_icon: 'assets/img/bed-bath/floorplan.svg',
  email_icon: 'assets/img/share-icons/email.svg',
  facebook_icon: 'assets/img/share-icons/facebook.svg',
  linkedin_icon: 'assets/img/share-icons/linkedin.svg',
  twitter_icon: 'assets/img/share-icons/twitter-x.svg',
  whattsapp_icon: 'assets/img/share-icons/whatsapp.svg',
  portrait_icon: 'assets/img/pdf-export-modal/portrait.svg',
  landscape_icon: 'assets/img/pdf-export-modal/landscape.svg',
  document_icon: 'assets/img/pdf-export-modal/document.svg',
  apartment_summary: 'assets/img/apartment-summary.svg',
  car_park_summary: 'assets/img/car-park-summary.svg',
  storage_summary: 'assets/img/storage-summary.svg',
  create_icon: 'assets/svg/create.svg',
  add_icon: 'assets/svg/matrix/add.svg',
  filter_icon: 'assets/svg/matrix/filter.svg',
  zoom_in_icon: 'assets/svg/matrix/zoomin.svg',
  zoom_out_icon: 'assets/svg/matrix/zoomout.svg',
  undo_icon: 'assets/svg/matrix/undo.svg',
  redo_icon: 'assets/svg/matrix/redo.svg',
  tag_icon: 'assets/svg/matrix/tag.svg',
  history_icon: 'assets/svg/matrix/history.svg',
  notes_icon: 'assets/svg/matrix/note.svg',
  settings_icon: 'assets/svg/matrix/setting.svg',
  project_1_icon: 'assets/menu-customisation-icons/Projects/projects1.svg',
  project_2_icon: 'assets/menu-customisation-icons/Projects/projects2.svg',
  project_3_icon: 'assets/menu-customisation-icons/Projects/projects3.svg',
  project_4_icon: 'assets/menu-customisation-icons/Projects/projects4.svg',
  project_5_icon: 'assets/menu-customisation-icons/Projects/projects5.svg',
  project_6_icon: 'assets/menu-customisation-icons/Projects/projects6.svg',
  project_7_icon: 'assets/menu-customisation-icons/Projects/projects7.svg',
  project_8_icon: 'assets/menu-customisation-icons/Projects/projects8.svg',
  project_9_icon: 'assets/menu-customisation-icons/Projects/projects9.svg',
};
